import { getAPI } from "@/axios-api";

/**
 * Fetch all services for an organization
 * @param {string} organizationId - The organization ID to fetch services for
 * @returns {Promise<Array>} List of services
 */
export async function fetchServices(organizationId) {
  try {
    // Get organization ID from parameter or fallback to localStorage
    const orgId = organizationId || localStorage.getItem('organisation');
    
    if (!orgId) {
      console.error('No organization ID provided');
      return [];
    }
    
    const response = await getAPI.get(`services/?organisation=${orgId}`);
    if (response.status === 200) {
      return response.data.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching services:', error);
    return [];
  }
}

/**
 * Create a new service
 * @param {string} serviceName - The name of the service to create
 * @param {string} organizationId - The organization ID
 * @returns {Promise<Object>} The created service object
 */
export async function createService(serviceName, organizationId) {
  try {
    const orgId = organizationId || localStorage.getItem('organisation');
    
    if (!serviceName || !orgId) {
      console.error('Service name or organization ID is missing');
      return null;
    }
    
    const response = await getAPI.post('services/', {
      name: serviceName,
      organisation: orgId
    });
    
    if (response.status === 201 || response.status === 200) {
      return response.data.data;
    }
    return null;
  } catch (error) {
    console.error('Error creating service:', error);
    return null;
  }
}

/**
 * Fetch users for a specific service
 * @param {string|number} serviceId - The ID of the service to fetch users for
 * @returns {Promise<Array>} List of users in the service
 */
export async function fetchServiceUsers(serviceId) {
  try {
    if (!serviceId) {
      console.error('Service ID is missing');
      return [];
    }
    
    const response = await getAPI.get(`services/get_users?service=${serviceId}`);
    if (response.status === 200) {
      return response.data.data;
    }
    return [];
  } catch (error) {
    console.error(`Error fetching users for service ${serviceId}:`, error);
    return [];
  }
}